<template>
    <v-container fluid class="portin-container" style="margin-top: 70px; margin-bottom: 70px;">

        <v-row class="d-flex justify-center" no-gutters>
            <v-col cols='12' no-gutters>
                <div class="header1">
                    <span class="text-center" style="font-weight: bold; font-size: 22px; padding-bottom: 10px;">ניהול
                        ניודים</span>
                </div>
            </v-col>
        </v-row>

        <v-row class="d-flex justify-center">
            <v-col cols='auto' lg='6'>
                <div class="header2">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="חיפוש" flat single-line hide-details
                        class="search">
                    </v-text-field>
                    <div class="d-flex flex-wrap pa-3">
                        <v-btn medium color="black" outlined dark class="mb-2 ms-2" style="border-color: #dddfe1">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" color="#9ea1a5" dark @click="downloadExcel()">
                                        mdi-file-download
                                    </v-icon>
                                </template>
                                <span>הורד לקובץ אקסל</span>
                            </v-tooltip>
                        </v-btn>
                    </div>
                </div>
            </v-col>
            <v-col cols='auto' lg='6' v-if="$vuetify.breakpoint.mdAndUp">
            </v-col>
        </v-row>

        <v-row class="d-flex justify-center">
            <v-data-table id="table1" class="portin-table" :headers="headers" :items="portinList" :search="search"
                sort-by="created_at" :sort-desc="true"
                :footer-props="{ 'items-per-page-options': [20, 50, 100, 500], 'items-per-page-text': 'שורות בעמוד:' }"
                style="background-color: #f3f6f9;">

                <template v-if="$vuetify.breakpoint.mdAndUp" v-for="header in headers"
                    v-slot:[`header.${header.value}`]="{ header }">
                    <span class="table-headers">{{ header.text }}</span>
                </template>

                <template v-if="$vuetify.breakpoint.mdAndUp" #item="{ item, index }">
                    <tr class="table-rows">
                        <td class="table-cells">{{ index + 1 }}</td>
                        <td class="table-cells">{{ item.userName || '-' }}</td>
                        <td class="table-cells">{{ item.phone }}</td>
                        <td class="table-cells">{{ item.tempNumber }}</td>
                        <td class="table-cells">{{ item.simNumber || '-' }}</td>
                        <td class="table-cells">{{ item.status }}</td>
                        <td class="table-cells message-cell">{{ item.portin_message || '-' }}</td>
                        <td class="table-cells date-cell">{{ item.portedAt || '-' }}</td>
                        <td class="table-cells">{{ item.packageLoaded }}</td>
                        <td class="table-cells message-cell">{{ item.packageLoaded_message || '-' }}</td>
                        <td class="table-cells date-cell">{{ item.created_at }}</td>
                        <td class="table-cells date-cell">{{ item.modified_at }}</td>
                        <td class="table-cells" style="text-align: center;">
                            <v-menu bottom right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="#fe3153" width="76" max-width="100%" height="32" v-bind="attrs"
                                        v-on="on" rounded>
                                        <span class="white--text cancle-button">פעולות</span>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-if="item.statusOriginal !== 'success'"
                                        @click="openEditDialog(item, index)">
                                        <v-list-item-icon>
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>ערוך ניוד</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="item.statusOriginal !== 'success'" @click="openDeleteDialog(item, index)">
                                        <v-list-item-icon>
                                            <v-icon>mdi-delete</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>מחק ניוד</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row v-if="progressShow" class="my-5">
                        <v-col class="d-flex justify-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-col>
                    </v-row>
                    <div class="ma-5">
                        <span class="text-center"
                            style="font-weight: bold; font-size: 25px; font-family: Times, serif;">אין
                            עדיין נתונים </span>
                    </div>
                    <v-btn color="#0099cd" dark @click="refreshDetails()" style="margin-bottom: 10px;">
                        Reset
                    </v-btn>
                </template>

            </v-data-table>
        </v-row>

        <EditDialog v-model="editDialog" v-if="editDialog" :formTitle="editFormTitle" :itemToEdit="editedItem"
            @portinEdited="portinEdited"> </EditDialog>

        <Alert-dialog v-model="alertDialog" v-if="alertDialog" :formTitle="formTitle" :item="itemToDelete"
            @portinDeleted="portinDeleted"> </Alert-dialog>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

    </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import TableToExcel from "@linways/table-to-excel";
import AlertDialog from '@/components/admin/portinPage/dialogs/Alertdialog.vue'
import EditDialog from '@/components/admin/portinPage/dialogs/EditDialog.vue'
import utils from '@/util/utils'

// ממיר תאריך בפורמט "dd/mm/yyyy, hh:mm:ss" למספר לצורך מיון (ריק = הכי ישן)
function dateStringToTime(dateString) {
    if (!dateString) return 0;
    const [datePart, timePart = '00:00:00'] = dateString.split(',').map(p => p.trim());
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds).getTime();
}

function sortByDate(a, b) {
    return dateStringToTime(a) - dateStringToTime(b);
}

// מוסיף רווח אחרי הפסיק כדי שהתאריך והשעה יוכלו לרדת לשתי שורות
function formatDate(date) {
    return utils.getCurrentDate(date).replace(',', ', ');
}

export default {
    components: {
        AlertDialog,
        EditDialog,
        SnackBar,
    },
    data: () => ({
        headers: [
            { text: '#', value: "index", sortable: false, width: "40px" },
            { text: 'שם משתמש', value: 'userName', width: "110px" },
            { text: 'מספר נייד', align: 'start', value: 'phone', width: "105px" },
            { text: 'מספר זמני', value: 'tempNumber', width: "105px" },
            { text: 'מספר סים', value: 'simNumber', width: "95px" },
            { text: 'סטטוס', value: 'status', width: "95px" },
            { text: 'הודעת ניוד', value: 'portin_message' },
            { text: 'תאריך ניוד', value: 'portedAt', width: "100px", sort: sortByDate },
            { text: 'סטטוס חבילה', value: 'packageLoaded', width: "85px" },
            { text: 'הודעת חבילה', value: 'packageLoaded_message' },
            { text: 'נוצר בתאריך', value: 'created_at', width: "100px", sort: sortByDate },
            { text: 'עודכן בתאריך', value: 'modified_at', width: "100px", sort: sortByDate },
            { text: 'פעולות', value: 'actions', sortable: false, width: "90px" },
        ],
        alertDialog: false,
        editDialog: false,
        formTitle: "",
        editFormTitle: "",
        portinList: [],
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        itemToDelete: {},
        editedItem: {},
        search: "",
    }),

    methods: {
        async getPortinDetails() {
            try {
                this.portinList = [];
                this.progressShow = true;
                let token = localStorage.getItem("token");

                let api = process.env.VUE_APP_BASE_URL + "/admin/portin_list";
                const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
                this.progressShow = false;
                const jsonObject = await res.json();
                if (res.status === 400) {
                    this.showSnackBar("שגיאה בקבלת נתונים", "red");
                } else if (res.status === 200) {
                    this.portinList = jsonObject;
                    this.translateToHebrewAndDates();
                }
            } catch (error) {
                this.progressShow = false;
                this.showSnackBar("Error get portin list: " + error, "red");
            }
        },

        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },

        translateToHebrewAndDates() {
            this.portinList = this.portinList.map((obj) => {
                // שמירת הסטטוס המקורי
                const statusOriginal = obj.status;
                const packageLoadedOriginal = obj.packageLoaded;

                // תרגום סטטוס ניוד
                let statusHebrew = obj.status;
                switch (obj.status) {
                    case 'pending':
                        statusHebrew = 'ממתין';
                        break;
                    case 'await_auth':
                        statusHebrew = 'ממתין לאישור';
                        break;
                    case 'await_portin':
                        statusHebrew = 'ממתין לניוד';
                        break;
                    case 'success':
                        statusHebrew = 'הצליח';
                        break;
                    case 'failed':
                        statusHebrew = 'נכשל';
                        break;
                }

                // תרגום סטטוס חבילה
                let packageLoadedHebrew = obj.packageLoaded;
                switch (obj.packageLoaded) {
                    case 'pending':
                        packageLoadedHebrew = 'ממתין';
                        break;
                    case 'success':
                        packageLoadedHebrew = 'הצליח';
                        break;
                    case 'failed':
                        packageLoadedHebrew = 'נכשל';
                        break;
                }

                return {
                    ...obj,
                    statusOriginal: statusOriginal, // שמירת הערך המקורי
                    packageLoadedOriginal: packageLoadedOriginal, // שמירת הערך המקורי
                    status: statusHebrew,
                    packageLoaded: packageLoadedHebrew,
                    userName: obj.User?.name || null,
                    created_at: formatDate(obj.created_at),
                    modified_at: formatDate(obj.modified_at),
                    portedAt: obj.portedAt ? formatDate(obj.portedAt) : null,
                }
            });
        },

        downloadExcel() {
            // Create a copy of the headers with English text
            const englishHeaders = [
                { text: '#', value: "index" },
                { text: 'user_name', value: 'userName' },
                { text: 'phone', value: 'phone' },
                { text: 'temp_number', value: 'tempNumber' },
                { text: 'sim_number', value: 'simNumber' },
                { text: 'status', value: 'status' },
                { text: 'portin_message', value: 'portin_message' },
                { text: 'ported_at', value: 'portedAt' },
                { text: 'package_loaded', value: 'packageLoaded' },
                { text: 'package_loaded_message', value: 'packageLoaded_message' },
                { text: 'created_at', value: 'created_at' },
                { text: 'modified_at', value: 'modified_at' },
                { text: 'פעולות', value: 'actions' },
            ];

            // Clone the table
            const table = document.getElementById('table1');
            const clonedTable = table.cloneNode(true);

            // Replace the table headers with the English headers in the cloned table
            const tableHeaders = clonedTable.getElementsByTagName('th');
            for (let i = 0; i < englishHeaders.length; i++) {
                tableHeaders[i].textContent = englishHeaders[i].text;
            }

            // Remove the first header (index)
            tableHeaders[0].parentNode.removeChild(tableHeaders[0]);
            // Remove the last header (actions)
            tableHeaders[tableHeaders.length - 1].parentNode.removeChild(tableHeaders[tableHeaders.length - 1]);

            // Remove the first and last columns from the cloned table
            const tableRows = clonedTable.getElementsByTagName('tr');
            for (let i = 0; i < tableRows.length; i++) {
                const tableCells = tableRows[i].getElementsByTagName('td');
                if (tableCells.length > 0) {
                    tableCells[0].parentNode.removeChild(tableCells[0]); // Remove the first cell (index)
                    tableCells[tableCells.length - 1].parentNode.removeChild(tableCells[tableCells.length - 1]); // Remove the last cell (actions)
                }
            }

            // Download the Excel file from the cloned table
            TableToExcel.convert(clonedTable, {
                name: 'portinList.xlsx',
                sheet: {
                    name: 'Sheet 1',
                },
            });
        },

        refreshDetails() {
            this.getPortinDetails();
        },

        openEditDialog(item, index) {
            this.editFormTitle = "ערוך ניוד"
            this.editedItem = { ...item }
            this.editDialog = true
        },

        openDeleteDialog(item, index) {
            this.itemIndex = index;
            this.itemToDelete = item
            this.formTitle = "האם אתה בטוח שברצונך למחוק את הניוד?"
            this.alertDialog = true
        },

        portinEdited(item, text, color) {
            this.showSnackBar(text, color)
            if (item === "") {
                return
            }
            // השרת מחזיר רק את מספר השורות שעודכנו, לכן טוענים את הרשימה מחדש
            this.getPortinDetails();
        },

        portinDeleted(item, text, color) {
            if (item === "") {
                this.showSnackBar(text, color)
                return
            }
            const index = this.portinList.findIndex(obj => obj.id === item.id);
            this.portinList.splice(index, 1);
            this.showSnackBar(text, color)
        },
    },

    mounted() {
        this.getPortinDetails();
    },
}
</script>

<style scoped>
.header1 {
    background-color: #fff;
    height: 89px;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
}

.header2 {
    min-height: 89px;
    display: flex;
}

.search {
    width: 332px !important;
    height: 49px;
    max-width: 100% !important;
    padding: 10px !important;
    padding-right: 10px !important;
    border: 1px solid #dddfe1 !important;
    box-sizing: border-box !important;
    font-size: 15px !important;
    font-family: "circular-std-book" !important;
}

.portin-container {
    padding-left: 24px;
    padding-right: 24px;
}

.portin-table {
    width: 100%;
}

.portin-table >>> th,
.portin-table >>> td {
    padding: 0 6px !important;
}

.table-headers {
    font-family: 'Circular-std-book' !important;
    font-size: 15px;
    font-weight: 100 !important;
}

.table-rows {
    background-color: #FFFFFF !important;
    height: 89px !important;
    box-shadow: -1.8369701465288538e-16px 3px 10px rgba(119, 119, 119, 0.1) !important;
    border-radius: 3px !important;
}

.table-cells {
    font-family: 'Circular-std-book' !important;
    font-size: 14px !important;
    color: #6a707e;
}

.message-cell {
    min-width: 140px;
    white-space: normal;
    word-break: break-word;
}

.date-cell {
    color: #abafb3 !important;
    white-space: normal;
    line-height: 1.4;
}

.cancle-button {
    font-size: 14px;
    font-family: 'Circular-std-book' !important;
}
</style>